import { GlButton, GlAnimatedChevronLgDownUpIcon, GlCollapse } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
import AgentStatusIcon from './agent_status_icon.vue?vue3';
import AgentSessionRow from './agent_session_row.vue?vue3';
export default {
    name: 'AgentSessionsGroup',
    components: {
        GlButton,
        GlAnimatedChevronLgDownUpIcon,
        GlCollapse,
        AgentStatusIcon,
        AgentSessionRow
    },
    props: {
        group: {
            type: Object,
            required: true
        },
        headerBgClass: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            collapsed: false
        };
    },
    computed: {
        toggleLabel () {
            return this.collapsed ? __('Expand') : __('Collapse');
        }
    }
};
